<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
    ></BusinessViewHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default" :disabled="is_loading" >
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Business Form "
      id="owner_delete_business_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="business_delete_form_ref"
      id="business_delete_form"
      message="<b>Delete was succesfull</b> <br/> Your business was removed successfully"
      :is_loading="is_loading || is_owner == false"
      :seed="{business:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
export default {
  name: "OwnerBusinessesDelete",
  components: {
      BusinessViewHeader,
      CardedSectionHeader,
      DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
    };
  },
  methods: {
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            //this.get_register_business_dependencies();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.business_delete_form_ref.show_error_dialog();
        }
      );
    },
    on_success(){
        this.$router.push("/owner/businesses/list");
    }
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Delete",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:
            "/owner/businesses/list/view/" +
            this.business_id +
            "/delete",
        },
      ],
      navbar_cols: 3,
    });
    // this.init_form();
    this.load_business(this.business_id);
  },
};
</script>